/*
  assets/lvlads-card-variant-link.js
  Swatches de color en las tarjetas de producto (colecciones, relacionados, etc.).

  El tema ya pinta los circulitos de color debajo del precio y, al hacer clic, cambia la
  imagen y el precio de la tarjeta (hdt-swatch-card -> evento "variant:updated"). Lo que no
  hace es llevar esa variante al enlace del producto: la ficha abria siempre con el color
  por defecto. Este script lo corrige:

    1. Cada vez que la tarjeta cambia de variante, todos sus enlaces [data-pr-url] pasan a
       incluir ?variant=ID, asi la imagen/titulo/boton abren la ficha con ese color.
    2. Si GO_TO_PRODUCT_ON_SWATCH_CLICK es true, el clic en el circulito manda directo a la
       ficha con ese color seleccionado (sin esperar un segundo clic en la tarjeta).
*/
(function () {
  var GO_TO_PRODUCT_ON_SWATCH_CLICK = true;

  function withVariant(href, variantId) {
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.set('variant', variantId);
      return url.pathname + url.search + url.hash;
    } catch (e) {
      return href;
    }
  }

  function updateCardLinks(card, variantId) {
    if (!card || !variantId) return;
    card.querySelectorAll('[data-pr-url]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href) a.setAttribute('href', withVariant(href, variantId));
    });
  }

  // 1. La tarjeta cambio de variante (imagen/precio ya actualizados por el tema).
  document.addEventListener('variant:updated', function (e) {
    var variant = e.detail && e.detail.variant;
    var card = e.target && e.target.closest ? e.target.closest('hdt-card-product') : null;
    if (variant && variant.id) updateCardLinks(card, variant.id);
  });

  // 2. Clic directo en el circulito -> ficha del producto con ese color.
  if (GO_TO_PRODUCT_ON_SWATCH_CLICK) {
    document.addEventListener('click', function (e) {
      var swatch = e.target && e.target.closest ? e.target.closest('hdt-swatch-card[data-vrid]') : null;
      if (!swatch) return;
      var card = swatch.closest('hdt-card-product');
      if (!card) return; // en la ficha de producto no aplica
      var cardLink = card.querySelector('[data-pr-url]');
      var link = swatch.dataset.productUrl || (cardLink && cardLink.getAttribute('href'));
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = withVariant(link, swatch.dataset.vrid);
    }, true);
  }
})();
